import {themeEl} from '@ui/root-el';
import {CssTheme} from '@ui/themes/css-theme';
import {setThemeValue} from '@ui/themes/utils/set-theme-value';
import {AppStatusBar} from '@common/core/capacitor/app-status-bar';
import {AppNavigationBar} from '@common/core/capacitor/app-navigation-bar';


function rgbToHex(rgb: string): string {
  // Convertit une chaîne RGB ("255 255 255") en hexadécimal ("#FFFFFF")
  const [r, g, b] = rgb.split(' ').map(Number);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
}

export function applyThemeToDom(theme: CssTheme) {
  Object.entries(theme.values).forEach(([key, value]) => {
    setThemeValue(key, value);
  });
  if (theme.is_dark) {
    themeEl.classList.add('dark');
  } else {
    themeEl.classList.remove('dark');
  }
  themeEl.dataset.themeId = `${theme.id}`;
  
  AppStatusBar.Theme();
  AppNavigationBar.Theme();
}
